export default __webpack_public_path__ + "2c1d31e6e148c3cf1d9d8aedf15370d0.svg";